import clsx from 'clsx';

export interface SegmentedTab {
  id: string;
  label: string;
  disabled?: boolean;
}

interface AnalyticsSegmentedControlProps {
  ariaLabel: string;
  tabs: SegmentedTab[];
  activeId?: string;
  isActive?: (id: string) => boolean;
  onChange: (id: string) => void;
  className?: string;
}

/** Same tab control as Overview, Statistics, and AI Insights. */
export function AnalyticsSegmentedControl({
  ariaLabel,
  tabs,
  activeId,
  isActive,
  onChange,
  className,
}: AnalyticsSegmentedControlProps) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={clsx(
        'inline-flex max-w-full flex-wrap gap-1 rounded-lg border border-[#E2E5EA] bg-page-bg p-[3px]',
        className,
      )}
    >
      {tabs.map((tab) => {
        const selected = isActive ? isActive(tab.id) : tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            disabled={tab.disabled}
            onClick={() => {
              if (!tab.disabled) onChange(tab.id);
            }}
            className={clsx(
              'inline-flex shrink-0 items-center whitespace-nowrap rounded-md px-3 py-1.5 text-[12px] transition-all duration-150 sm:text-[13px]',
              tab.disabled && 'cursor-not-allowed opacity-40',
              selected
                ? 'bg-white font-semibold text-blueprint-blue shadow-[0_1px_3px_rgba(0,0,0,0.06)]'
                : 'font-medium text-heritage-grey hover:text-blueprint-blue',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
